import { Menu, MenuItem } from "@mui/material";
import { Eye, Trash2 } from "lucide-react";
import PropTypes from "prop-types";

const TemplateActionsMenu = ({ anchorEl, open, onClose, onView, onDelete }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      data-testid="template-actions-menu"
    >
      <MenuItem onClick={onView} data-testid="template-view-action">
        <Eye size={18} style={{ marginRight: 8 }} />
        View
      </MenuItem>
      <MenuItem
        onClick={onDelete}
        sx={{ color: "error.main" }}
        data-testid="template-delete-action"
      >
        <Trash2 size={18} style={{ marginRight: 8 }} />
        Delete
      </MenuItem>
    </Menu>
  );
};

TemplateActionsMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default TemplateActionsMenu;
